import { render, staticRenderFns } from "./Corporate-Expenses.vue?vue&type=template&id=755018e0&scoped=true"
import script from "./Corporate-Expenses.vue?vue&type=script&lang=js"
export * from "./Corporate-Expenses.vue?vue&type=script&lang=js"
import style0 from "./Corporate-Expenses.vue?vue&type=style&index=0&id=755018e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755018e0",
  null
  
)

export default component.exports